import { render, staticRenderFns } from "./fromStoresTransfers.vue?vue&type=template&id=647ad76c"
import script from "./fromStoresTransfers.vue?vue&type=script&lang=js"
export * from "./fromStoresTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports